import {
    CLEAR_ASSISTANT_OUTPUT,
    GET_ASSISTANTS_BY_ID,
    GET_ASSISTANTS_FAIL,
    GET_ASSISTANTS_REQUEST,
    GET_ASSISTANTS_SUCCESS,
    GET_ASSISTANT_PROMPT_OUTPUT
} from "../constant";

const initialState = {
    data: [],
    assistant_output: {},
    assistant: {},
    assistantDataLoading: false,
    assistant_list: []
};

export const assistantsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ASSISTANTS_REQUEST:
            return {
                ...state,
                assistantDataLoading: true,
            };
        case GET_ASSISTANTS_SUCCESS:
            return {
                ...state,
                assistantDataLoading: false,
                data: [...action.payload],
                assistant_list : action.payload
            };
        case GET_ASSISTANTS_FAIL:
            return {
                ...state,
                assistantDataLoading: false,
            };
        case GET_ASSISTANTS_BY_ID:
            return {
                ...state,
                assistant: action.payload
            }
        case GET_ASSISTANT_PROMPT_OUTPUT:
            return {
                ...state,
                assistant_output: action.payload,
            };
        case CLEAR_ASSISTANT_OUTPUT:
            return {
                ...state, assistant_output: {}
            }

        default:
            return state;
    }
}